import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { employeesTableStoreCreator, type EmployeesTableStore } from './creator'

export const useEmployeesTableStore = create<EmployeesTableStore>()(
  persist(employeesTableStoreCreator, {
    name: '@SwileCorporates:table-employee-selection',
    storage: createJSONStorage(() => sessionStorage)
  })
)
